import {Component, OnInit} from '@angular/core';
import {GlobalIntegrationService} from '../../../shared/services/globalIntegration.service';
import {CoreService} from '../../../core/data-services/core.service';
import {AuthenticationService} from '../../../core/services/authentication.service';
import {SimpleEventsQueryResource} from '../../../shared/models/resources/simpleEventsQueryResource.model';
import {CONFIG} from '../../../config';
import {TranslateService} from '@ngx-translate/core';
import {SimpleQueryFiltersResource} from '../../../shared/models/resources/simpleQueryFiltersResource.model';
import {SimplePaginatedEventsQueryResource} from '../../../shared/models/resources/simplePaginatedEventsQueryResource.model';
import {SimpleEventsEmailResource} from '../../../shared/models/resources/simpleEventsEmailResource.model';
import {JqueryCommonService} from '../../../shared/services/jquery-common.service';
import {BannerNotificationsService, SpinnerService} from '../../../xform-compat';

@Component({
  standalone: false,
    selector: 'cci-search-panel',
    templateUrl: './search-panel.component.html',
    styleUrls: ['./search-panel.component.scss']
})
export class SearchPanelComponent implements OnInit {

    public start: string;
    public end: string;
    public calendars: string;

    public allTerms: string;
    public anyTerms: string;
    public noTerms: string;
    public externalOnly: boolean;
    public pubPrivConfGovtOnly: boolean;

    private page: number;
    private countPerPage: number;
    private sortFieldName: string;
    private sortType: string;

    private DEFAULT_PAGE = 1;
    private DEFAULT_COUNT_PER_PAGE = CONFIG.pagination.allowedRanges[0].range;
    private DEFAULT_SORT_FIELD_NAME = 'EVENTSTART';
    private DEFAULT_SORT_TYPE = 'ASC';

    private FORM_UPDATE_ANIMATION_CLASS = 'cci-form-update-animation';

    public showErrors = false;

    constructor(
        private globalIntegrationService: GlobalIntegrationService,
        private authenticationService: AuthenticationService,
        private bannerNotificationsService: BannerNotificationsService,
        private spinnerService: SpinnerService,
        private translateService: TranslateService,
        private jqueryCommonService: JqueryCommonService,
        private coreService: CoreService,
    ) {
    }

    ngOnInit() {
        this.initSavedQueryLoadEventEmitter();
        this.initPaginationChangeEventEmitter();
        this.initTableSortEventEmitter();
    }

    public isFormValid() {
        // TODO: add more validation here, or have the form check itself
        return (this.calendars && this.start && this.end);
    }

    public initSavedQueryLoadEventEmitter() {
        this.globalIntegrationService.savedQueryLoadEventEmitter.subscribe(event => {
            const eventsQueryResource = (event as SimpleEventsEmailResource).eventsQueryResource;
            this.start = this.ISOToDateTime(eventsQueryResource.startDateISO);
            this.end = this.ISOToDateTime(eventsQueryResource.endDateISO);
            this.calendars = eventsQueryResource.calendars.join(',');

            const queryFilters = eventsQueryResource.queryFilters;
            if (queryFilters == null) {
                this.allTerms = null;
                this.anyTerms = null;
                this.noTerms = null;
                this.externalOnly = false;
                this.pubPrivConfGovtOnly = false;
            } else {
                this.allTerms = queryFilters.includeWords ? queryFilters.includeWords.join(',') : null;
                this.anyTerms = queryFilters.includeAnyWords ? queryFilters.includeAnyWords.join(',') : null;
                this.noTerms = queryFilters.excludeWords ? queryFilters.excludeWords.join(',') : null;
                this.externalOnly = queryFilters.externalOnly;
                this.pubPrivConfGovtOnly = queryFilters.pubPrivConfGovtOnly;
            }

            this.jqueryCommonService.triggerFormUpdateAnimation('cci-search-input'.toClass(), this.FORM_UPDATE_ANIMATION_CLASS);
        });
    }

    public initPaginationChangeEventEmitter() {
        this.globalIntegrationService.paginationChangeEventEmitter.subscribe((event) => {
            this.page = event.page;
            this.countPerPage = event.countPerPage;
            this.search();
        });
    }

    public constructEventsQueryResource() {
        const calendars = this.calendars.split(',');
        calendars.forEach((calendar, i) => {
            calendars[i] = calendar.trim();
        });
        const allTerms = this.allTerms ? this.allTerms.split(',') : [];
        const anyTerms = this.anyTerms ? this.anyTerms.split(',') : [];
        const noTerms = this.noTerms ? this.noTerms.split(',') : [];
        const externalOnly = this.externalOnly;
        const pubPrivConfGovtOnly = this.pubPrivConfGovtOnly;

        const queryFilters = new SimpleQueryFiltersResource({
            includeWords: allTerms,
            includeAnyWords: anyTerms,
            excludeWords: noTerms,
            externalOnly: externalOnly,
            pubPrivConfGovtOnly: pubPrivConfGovtOnly,
        });

        const eventsQueryResource = new SimpleEventsQueryResource({
            startDateISO: this.formatDateTime(this.start),
            endDateISO: this.formatDateTime(this.end + 'T23:59:59'),
            calendars: calendars,
            queryFilters: queryFilters,
        });
        console.warn(eventsQueryResource);

        return eventsQueryResource;
    }

    public search(clearSort?: boolean) {
        console.warn(this.start, this.end, this.page, this.countPerPage, this.calendars, this.allTerms, this.anyTerms, this.noTerms, this.externalOnly);
        if (clearSort) {
            this.sortFieldName = this.DEFAULT_SORT_FIELD_NAME;
            this.sortType = this.DEFAULT_SORT_TYPE;
        }
        const eventsQueryResource = this.constructEventsQueryResource();
        this.globalIntegrationService.simpleEventsQueryResource = eventsQueryResource;
        const query = new SimplePaginatedEventsQueryResource({
            page: (this.page) ? this.page : this.DEFAULT_PAGE,
            countPerPage: (this.countPerPage) ? this.countPerPage : this.DEFAULT_COUNT_PER_PAGE,
            eventsQueryResource: eventsQueryResource,
            sortFieldName: typeof (this.sortFieldName) !== 'undefined' ? this.sortFieldName : this.DEFAULT_SORT_FIELD_NAME,
            sortType: typeof (this.sortType) !== 'undefined' ? this.sortType : this.DEFAULT_SORT_TYPE
        });
        console.warn(query);

        this.spinnerService.start();
        this.coreService.eventsQuery(query).subscribe((result: any) => {
            this.spinnerService.stop();
            result.resetSort = clearSort;
            this.globalIntegrationService.eventsQuerySearchEventEmitter.next(result);
        }, (response) => {
            this.spinnerService.stop();
            console.error(response);
            if (response.error instanceof ProgressEvent) {
                return this.bannerNotificationsService.error('Timeout error: Try selecting a smaller date range or reduce the number of calendars to search');
            }
            const errorCode = (response && response.error) ? response.error.code : CONFIG.authErrorCode;
            if (errorCode === 'BUS_3005') {
                return this.bannerNotificationsService.error(response.error.message);
            }
            this.bannerNotificationsService.error(this.translateService.instant(`API_ERRORS.${errorCode}`));
        });
    }

    public saveCurrentQuery() {
        const eventsQueryResource = this.constructEventsQueryResource();
        this.globalIntegrationService.simpleEventsQueryResource = eventsQueryResource;
        this.globalIntegrationService.eventsQuerySaveEventEmitter.next(eventsQueryResource);
    }

    public initTableSortEventEmitter() {
        this.globalIntegrationService.calendarHeaderSortChangeEventEmitter.subscribe((data) => {
            this.sortFieldName = data.sortFieldName;
            this.sortType = data.sortType;
            this.search();
        });
    }

    public setToCurrentDate() {
        const todayStart = new Date();
        todayStart.setUTCHours(0, 0, 0, 1);

        const todayEnd = new Date();
        todayEnd.setUTCHours(23, 59, 59);

        this.start = this.ISOToDateTime(todayStart.toISOString());
        this.end = this.ISOToDateTime(todayEnd.toISOString());
    }

    public setToTomorrow() {
        const tomorrowStart = new Date();
        tomorrowStart.setUTCDate(tomorrowStart.getUTCDate() + 1);
        tomorrowStart.setUTCHours(0, 0, 0, 1);

        const tomorrowEnd = new Date();
        tomorrowEnd.setUTCDate(tomorrowEnd.getUTCDate() + 1);
        tomorrowEnd.setUTCHours(23, 59, 59);

        this.start = this.ISOToDateTime(tomorrowStart.toISOString());
        this.end = this.ISOToDateTime(tomorrowEnd.toISOString());
    }

    private formatDateTime(yyyymmdd: string) {
        return yyyymmdd ? this.dateTimeToISO(yyyymmdd) : null;
    }

    private dateTimeToISO(yyyymmdd: string) {
        return new Date(yyyymmdd + 'Z').toISOString();
    }

    private ISOToDateTime(iso: string) {
        return iso.substring(0, 10);
    }

}
